import React from 'react';
import PropTypes from 'prop-types';
import RangeFilter from './RangeFilter';

const numericType = 'numeric';
const labelsType = 'labels';

const ConfigurableRangeFilter = ({ title, min, max, onChange, className, config }) => {
    const {
        rangeMin,
        rangeMax,
        customRangeDisplay,
        scaleData,
        isHalfSteps = false,
        scaleClassName = 'range-number',
    } = config;

    const handleRangeChange = (values) => {
        if (onChange) {
            onChange(values);
        }
    };

    const renderScale = () => {
        if (scaleData.type === numericType) {
            const { start, end } = scaleData;
            return Array.from({ length: end - start + 1 }, (_, i) => i + start).map(number => (
                <div className={scaleClassName} key={`scale-${number}`}>
                    {number}
                </div>
            ));
        }

        if (scaleData.type === labelsType) {
            return scaleData.items.map((item) => (
                <div className={scaleClassName} key={`scale-${item.id}`}>
                    {item.label}
                </div>
            ));
        }
        return null;
    };

    return (
        <div className={`${className || ''}`}>
            <RangeFilter
                title={title}
                rangeKeyMin={rangeMin}
                rangeKeyMax={rangeMax}
                defaultValueArr={[min, max]}
                min={min}
                max={max}
                onChange={handleRangeChange}
                customRangeDisplay={customRangeDisplay}
                isHalfSteps={isHalfSteps}
            />
            <div className="range-scale">
                {renderScale()}
            </div>
        </div>
    );
};

ConfigurableRangeFilter.propTypes = {
    title: PropTypes.string.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    onChange: PropTypes.func,
    className: PropTypes.string,
    config: PropTypes.shape({
        rangeMin: PropTypes.number.isRequired,
        rangeMax: PropTypes.number.isRequired,
        customRangeDisplay: PropTypes.func,
        scaleData: PropTypes.shape({
            type: PropTypes.oneOf([numericType, labelsType]).isRequired,
            start: PropTypes.number,
            end: PropTypes.number,
            items: PropTypes.array,
        }).isRequired,
        isHalfSteps: PropTypes.bool,
        scaleClassName: PropTypes.string,
    }).isRequired,
};

ConfigurableRangeFilter.defaultProps = {
    onChange: () => {},
    className: '',
};

export default ConfigurableRangeFilter;
